<template>
  <div>
    <b-modal ref="confirmModal"
             header-bg-variant="light"
             header-text-variant="danger"
             centered
             hide-header-close
             size="sm"
             hide-footer>
      <template #modal-title>
        {{ title }}
      </template>
      <div class="d-block text-center">
        <h5>{{ message }}</h5>
      </div>

      <div class="row my-4">
        <div class="col-6 text-center">
          <button class="btn btn-secondary" @click="hide">
            <span class="mdi mdi-close"></span> {{ $t("#TR-cancel") }}
          </button>
        </div>
        <div class="col-6 text-center">
          <button class="btn btn-danger" @click="onOK">
            <span class="mdi mdi-trash-can"></span> {{ $t("#TR-delete") }}
          </button>
        </div>
      </div>

    </b-modal>
  </div>
</template>

<script>
  export default {
    name: 'Test',

    data() {
      return {
        title: '',
        message: '',
        dish: null
      };
    },

    methods: {

      show(data) {
        this.title = data.title ? data.title : 'Title';
        this.message = data.message ? data.message : 'Message';
        this.dish = data.prop ? data.prop : null;
        this.$refs.confirmModal.show();
      },

      hide() {
        this.dish = null;
        this.$refs.confirmModal.hide();
      },

      onOK() {
        this.$emit('confirm', this.dish);
        this.hide();
      }
    }
  };
</script>

<style lang="scss" scoped>

</style>
